import React from "react";
import "flag-icons/css/flag-icons.min.css";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./ui/select";
import { visitorLang } from "../lib/api";

import { tr } from "../i18n";
export const DIAL_CODES = [
  { code: "+44", label: "UK +44", id: "UK" },
  { code: "+49", label: "DE +49", id: "DE" },
  { code: "+41", label: "CH +41", id: "CH" },
  { code: "+376", label: "AD +376", id: "AD" },
  { code: "+355", label: "AL +355", id: "AL" },
  { code: "+43", label: "AT +43", id: "AT" },
  { code: "+387", label: "BA +387", id: "BA" },
  { code: "+32", label: "BE +32", id: "BE" },
  { code: "+359", label: "BG +359", id: "BG" },
  { code: "+375", label: "BY +375", id: "BY" },
  { code: "+357", label: "CY +357", id: "CY" },
  { code: "+420", label: "CZ +420", id: "CZ" },
  { code: "+45", label: "DK +45", id: "DK" },
  { code: "+372", label: "EE +372", id: "EE" },
  { code: "+34", label: "ES +34", id: "ES" },
  { code: "+358", label: "FI +358", id: "FI" },
  { code: "+33", label: "FR +33", id: "FR" },
  { code: "+30", label: "GR +30", id: "GR" },
  { code: "+385", label: "HR +385", id: "HR" },
  { code: "+36", label: "HU +36", id: "HU" },
  { code: "+353", label: "IE +353", id: "IE" },
  { code: "+354", label: "IS +354", id: "IS" },
  { code: "+39", label: "IT +39", id: "IT" },
  { code: "+423", label: "LI +423", id: "LI" },
  { code: "+370", label: "LT +370", id: "LT" },
  { code: "+352", label: "LU +352", id: "LU" },
  { code: "+371", label: "LV +371", id: "LV" },
  { code: "+377", label: "MC +377", id: "MC" },
  { code: "+373", label: "MD +373", id: "MD" },
  { code: "+382", label: "ME +382", id: "ME" },
  { code: "+389", label: "MK +389", id: "MK" },
  { code: "+356", label: "MT +356", id: "MT" },
  { code: "+31", label: "NL +31", id: "NL" },
  { code: "+47", label: "NO +47", id: "NO" },
  { code: "+48", label: "PL +48", id: "PL" },
  { code: "+351", label: "PT +351", id: "PT" },
  { code: "+40", label: "RO +40", id: "RO" },
  { code: "+381", label: "RS +381", id: "RS" },
  { code: "+7", label: "RU +7", id: "RU" },
  { code: "+46", label: "SE +46", id: "SE" },
  { code: "+386", label: "SI +386", id: "SI" },
  { code: "+421", label: "SK +421", id: "SK" },
  { code: "+378", label: "SM +378", id: "SM" },
  { code: "+380", label: "UA +380", id: "UA" },
  { code: "+379", label: "VA +379", id: "VA" },
  { code: "+383", label: "XK +383", id: "XK" },
];

const KEEP_ZERO = new Set(["+39", "+379"]);
const byId = Object.fromEntries(DIAL_CODES.map((d) => [d.id, d]));
const flag = (id) => `fi fi-${id === "UK" ? "gb" : id.toLowerCase()}`;

export const defaultDial = () => ({ de: "DE", es: "ES", fr: "FR", it: "IT" })[visitorLang()] || "UK";

export const fullPhone = (dialId, number) => {
  const n = number.trim();
  if (n.startsWith("+")) return n;
  const dial = byId[dialId].code;
  return `${dial} ${KEEP_ZERO.has(dial) ? n : n.replace(/^0+/, "")}`;
};

export const phoneValid = (number) => number.replace(/\D/g, "").replace(/^0+/, "").length >= 6;

export default function PhoneInput({ dial, number, onDial, onNumber, testid, placeholder = "Phone" }) {
  return (
    <div className="flex gap-2">
      <Select value={dial} onValueChange={onDial}>
        <SelectTrigger data-testid={`${testid}-dial`} aria-label={tr("Country code")}
          className="rh-input !w-[120px] shrink-0 !h-auto gap-1">
          <span className="flex items-center gap-2.5"><span className={`${flag(dial)} rounded-[2px]`} /><span>{byId[dial].code}</span></span>
        </SelectTrigger>
        <SelectContent className="max-h-72 z-[200]">
          {DIAL_CODES.map((d) => (
            <SelectItem key={d.id} value={d.id} data-testid={`${testid}-dial-${d.id}`}>
              <span className="flex items-center gap-2"><span className={`${flag(d.id)} rounded-[2px]`} />{d.label}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <input required type="tel" inputMode="tel" data-testid={testid} value={number}
        onChange={(e) => onNumber(e.target.value)} placeholder={tr(placeholder)} className="rh-input min-w-0 flex-1" />
    </div>
  );
}
